import { render, staticRenderFns } from "./msw-dp-login.vue?vue&type=template&id=2621cfa5&scoped=true&"
import script from "./msw-dp-login.vue?vue&type=script&lang=ts&"
export * from "./msw-dp-login.vue?vue&type=script&lang=ts&"
import style0 from "./msw-dp-login.vue?vue&type=style&index=0&id=2621cfa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621cfa5",
  null
  
)

export default component.exports